import React, { useRef, useState, useLayoutEffect } from 'react';
import { Router } from 'react-router-dom';

import { FilteredRoutes } from '@app/dev/components/router/components/generateRoute';
import { routeDefinitions } from '@app/dev/components/router/routes/route';
import { browserHistory } from '@common/helpers/browserHistory';

const RouterBuilder = () => {
  const historyRef = useRef();

  if (historyRef.current == null) {
    historyRef.current = browserHistory;
  }

  const history = historyRef.current;

  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen((location, action) => {
    setState({
      action,
      location,
    });
  }), [history]);

  return (
    <Router
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      <FilteredRoutes routeDefs={routeDefinitions} />
    </Router>
  );
};
export default RouterBuilder;
